import { render, staticRenderFns } from "./CommissionTypeAccountingConfigurationList.vue?vue&type=template&id=5acc252d"
import script from "./CommissionTypeAccountingConfigurationList.vue?vue&type=script&lang=js"
export * from "./CommissionTypeAccountingConfigurationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports